define [], () ->
  ($scope, $state, $stateParams, $window, $rootScope, $cacheFactory) ->
    $scope.success_svg = require('./group-4.svg')
    $scope.context = $stateParams.context
    $scope.application = $stateParams.application

    $scope.vendor_name = if $stateParams.vendor == 'smartmove' then 'Transunion' else 'Experian'

    $scope.go_to_dashboard = () ->
      if $rootScope.stored_form_data
        $cacheFactory.get("$http").removeAll()
        $state.go "root.forms.select_reports"
      else
        $window.location.href = $rootScope.HOST + "/dashboard/forms"

    $scope.next = () ->
      if $scope.application.need_applicant_finicity_bank_connection
        $state.go("root.applications.income", {application_id: $stateParams.application_id, application: $scope.application })
      else if $scope.context == 'applicant-payment'
        $state.go('root.payment.pay')
      else
        $state.go("root.applications.pay", { application: $scope.application, application_id: $stateParams.application_id})



// WEBPACK FOOTER //
// ./components/verifications/success/success.coffee